import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import { EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_METER } from '../config/exploreUnknownRewriteExperience';
import { EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_LOSS_DARKNESS_INCREMENT_PERCENT } from '../config/exploreUnknownMissionBattle';
import '../BattleUIExploreUnknownDarknessFlash.css';

/**
 * @param {{ popupId: string, newCharges: number, onDismiss: () => void }} props
 */
export default function ExploreUnknownRewriteSetCompleteModal({ popupId, newCharges, onDismiss }) {
  const { t } = useTranslation();

  useEffect(() => {
    playSoundEffect('/sounds/legendary_reveal.mp3');
  }, [popupId]);

  return createPortal(
    <div className="battle-eu-heart-set-complete-overlay explore-unknown-reward-popup-overlay" onClick={onDismiss}>
      <div
        className="battle-eu-heart-set-complete-modal battle-eu-heart-set-complete-modal--rewrite explore-unknown-reward-popup-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="explore-unknown-rewrite-set-complete-title"
      >
        <h3 id="explore-unknown-rewrite-set-complete-title" className="battle-eu-heart-set-complete-title">
          {t('exploreUnknownBattle.rewriteExperienceSetCompleteTitle')}
        </h3>
        <div className="battle-eu-heart-set-complete-visual">
          <img
            src={EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_METER.image}
            alt=""
            className="battle-eu-heart-set-complete-image"
          />
        </div>
        <p className="battle-eu-heart-set-complete-body">
          {t('exploreUnknownBattle.rewriteExperienceSetCompleteBody', {
            charges: newCharges,
            darknessPercent: EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_LOSS_DARKNESS_INCREMENT_PERCENT,
          })}
        </p>
        <button type="button" className="battle-eu-heart-set-complete-ok" onClick={onDismiss}>
          {t('exploreUnknownBattle.rewriteExperienceSetCompleteOk')}
        </button>
      </div>
    </div>,
    document.body
  );
}
